import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, share } from 'rxjs/operators'
import { mapOptions } from '@core/utils/options.utils'
import { LazyParams } from '@shared/components/table/table.models'

import { BoPlayer, BoPlayerEditableOptions, BoPlayerPosition } from './players-manager.models'
import { environment } from '@env'
import { logError } from '@shared/opretators/log-error.operator'
import { ignoreHeaderOverride } from '@core/requests/json-content-type.interceptor'

@Injectable()
export class PlayersManagerApi {
  readonly #http = inject(HttpClient)

  fetchPlayers$(params = {}, lazyParams: LazyParams = {} as LazyParams) {
    const paramsBackEnd = {
      filtering: {
        freeText: '',
        ...params,
      },
      ...lazyParams,
    }
    return this.#http
      .post<{
        players: BoPlayer[]
        [key: string]: any
      }>(environment.API.SEARCH_PLAYERS, paramsBackEnd)
      .pipe(
        map((data) => ({
          ...data,
          paging: {
            totalRecords: data.players.length,
            ...data['paging'],
          },
          sorting: {
            ...data['sorting'],
            ...lazyParams.sorting,
          },
        })),
        share(),
        logError(),
      )
  }

  fetchTeams$(params = {}) {
    return this.#http
      .post<{
        teams: any[]
        [key: string]: any
      }>(environment.API.SEARCH_TEAMS, params)
      .pipe(
        map((data) => mapOptions(data.teams, true)),
        share(),
        logError(),
      )
  }

  fetchPositions$() {
    return this.#http.get<BoPlayerPosition[]>(environment.API.GET_PLAYER_POSITIONS)
  }

  updatePlayer$(params: { players: BoPlayerEditableOptions[] }) {
    return this.#http.put<{ players: BoPlayerEditableOptions[] }>(
      environment.API.UPDATE_PLAYER,
      params,
    )
  }

  uploadPlayerFiles$(files: any, seasonId) {
    return this.#http.post<any>(environment.API.UPLOAD_PLAYER_FILES(seasonId), files, {
      context: ignoreHeaderOverride(),
      responseType: 'text',
    } as any)
  }
}
